export default {
  beforeMount(el: any, binding: any) { // eslint-disable-line
    el.clickOutsideEvent = function (event: Event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el: any) { // eslint-disable-line
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
};
